/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Invoiced_Sub_OneInputs */



/**
* | output |
* | --- |
* | "Invoice sent, payment not received · 1 invoice" |
*
* @param {Partner_Billing_Board_Invoiced_Sub_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_invoiced_sub_one = /** @type {((inputs?: Partner_Billing_Board_Invoiced_Sub_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Invoiced_Sub_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Rechnung versendet, Zahlung nicht eingegangen · 1 Rechnung")
	return /** @type {LocalizedString} */ ("Invoice sent, payment not received · 1 invoice")
});